import { extend } from '../../vue';
import { NAME_FORM_RADIO } from '../../constants/components';
import { makePropsConfigurable } from '../../utils/props';
import { formRadioCheckMixin, props as formRadioCheckProps } from '../../mixins/form-radio-check'; // --- Props ---

export var props = makePropsConfigurable(formRadioCheckProps, NAME_FORM_RADIO); // --- Main component ---
// @vue/component

export var BFormRadio = /*#__PURE__*/extend({
  name: NAME_FORM_RADIO,
  mixins: [formRadioCheckMixin],
  inject: {
    getBvGroup: {
      from: 'getBvRadioGroup',
      default: function _default() {
        return function () {
          return null;
        };
      }
    }
  },
  props: props,
  computed: {
    bvGroup: function bvGroup() {
      return this.getBvGroup();
    }
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/bootstrap-vue@2.23.1_jquery@3.7.1_vue@2.6.14/~/bootstrap-vue/esm/components/form-radio/form-radio.js
// module id = rc3S
// module chunks = 5